import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import Routes from './routes'

import DigitalAssetEdit from './DigitalAssetEdit'
import DigitalAssetList from './DigitalAssetList'

const DigitalAssetPage = () => {
  return (
    <Switch>
      <Route path={Routes.List} exact={true}>
        <DigitalAssetList />
      </Route>
      <Route path={Routes.Edit} exact={true}>
        <DigitalAssetEdit />
      </Route>
      <Redirect to={Routes.List} />
    </Switch>
  )
}

export default DigitalAssetPage
